<template>
    <div class="assessment-questions-options mb-5">
        <form action="#">
            <div class="option" v-for="answer in answers">
                <input type="radio"
                       :id="'opt-'+answer.id"
                       name="radio-group"
                       :value="answer.id">
                <label :for="'opt-'+answer.id"
                       :class="noAnsweredClass"
                       @click="answerSelected(answer.id)"
                       v-html="!!answer.label? answer.label: getImageTag(answer.assets)"></label>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        mounted(){
            this.answer = this.initAnswer;
            if(this.answer !== null){
                $('#opt-'+this.answer).prop('checked',true);
            }
            prolitEvents.$on('ShowNotAnswered',ev=>{
                this.showNoAnswered=true;
            });

        },
        props: {
            answers: {
                required: true
            },
            initAnswer:{
                default: null
            }
        },
        data() {
            return {
                showNoAnswered:false,
                answer:null
            }
        },
        computed:{
            noAnsweredClass(){
                return (this.showNoAnswered && this.answer === null) ? 'noAnswer' : '';
            }
        },
        methods: {
            getImageTag(url) {
                return '<img src="' + url + '"/>'
            },
            answerSelected(id) {
                this.answer = id;
                prolitEvents.$emit('AnswerSelected', id);
            }
        }
    }
</script>

<style>
    .noAnswer{
        color: #ee3126 !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/numeracyLiteracy/LiteracyAnswers.vue